// frontend/src/components/layout/Sidebar/Sidebar.tsx

import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
    isOpen: boolean;
    onToggle: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle }) => {
    return (
        <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
            <div className="sidebar-header">
                <div className="sidebar-logo">
                    <span className="logo-icon">📊</span>
                    {isOpen && <span className="logo-text">AutoSAGE</span>}
                </div>
                <button
                    className="sidebar-toggle"
                    onClick={onToggle}
                    title={isOpen ? 'Fechar menu' : 'Abrir menu'}
                >
                    {isOpen ? '◀' : '▶'}
                </button>
            </div>

            <nav className="sidebar-nav">
                {/* INÍCIO */}
                {isOpen && <div className="nav-divider">🚀 INÍCIO</div>}

                <NavLink
                    to="/csv-upload"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📥</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Adicionar Dados</span>
                            <span className="nav-text-secondary">Upload / Generator</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/orc"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">🔧</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Processar</span>
                            <span className="nav-text-secondary">ORC Pipeline</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/monitor"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📡</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Acompanhar</span>
                            <span className="nav-text-secondary">Pipeline Monitor</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/datasets"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📋</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Meus Dados</span>
                            <span className="nav-text-secondary">Datasets</span>
                        </div>
                    )}
                </NavLink>

                {/* VISÃO DE NEGÓCIO */}
                {isOpen && <div className="nav-divider">📈 VISÃO DE NEGÓCIO</div>}

                <NavLink
                    to="/scientific-dashboard"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📖</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Jornada dos Dados</span>
                            <span className="nav-text-secondary">Scientific Dashboard</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/dashboard"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📊</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Visão Geral</span>
                            <span className="nav-text-secondary">Dashboard</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/analysis"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">🔬</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Análise Científica</span>
                            <span className="nav-text-secondary">Scientific Analysis</span>
                        </div>
                    )}
                </NavLink>

                {/* VISÃO CIENTÍFICA */}
                {isOpen && <div className="nav-divider">🧪 VISÃO CIENTÍFICA</div>}

                <NavLink
                    to="/eda"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📈</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Exploração de Dados</span>
                            <span className="nav-text-secondary">EDA</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/eda-prepare"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">🧹</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Preparação</span>
                            <span className="nav-text-secondary">EDA Prepare</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/ml"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">🤖</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Treinamento</span>
                            <span className="nav-text-secondary">ML Experiments</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/ml-compare"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">⚖️</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Comparação de Modelos</span>
                            <span className="nav-text-secondary">ML Compare</span>
                        </div>
                    )}
                </NavLink>

                <NavLink
                    to="/ml-predict"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">🎯</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Predições</span>
                            <span className="nav-text-secondary">ML Predict</span>
                        </div>
                    )}
                </NavLink>

                {/* AJUDA */}
                {isOpen && <div className="nav-divider">📚 AJUDA</div>}

                <NavLink
                    to="/manual"
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                    <span className="nav-icon">📚</span>
                    {isOpen && (
                        <div className="nav-text-group">
                            <span className="nav-text-primary">Manual</span>
                            <span className="nav-text-secondary">Guia de Uso</span>
                        </div>
                    )}
                </NavLink>
            </nav>

            <div className="sidebar-footer">
                {isOpen ? (
                    <span className="version">AutoSAGE v1.0.0</span>
                ) : (
                    <span className="version-short">v1.0</span>
                )}
            </div>
        </aside>
    );
};